module.exports = __webpack_public_path__ + "assets/img/960a1604fd0418b11a2d39ddfc46c29f.webp";